// 從貼文/世界觀資料中取得唯一 id，供列表本地 patch（按讚/收藏/留言等樂觀更新）比對用
// 混合列表（標籤/收藏/搜尋模式）同時有 post 與 world，兩者的 auto-increment id 可能撞號，
// 一律加上類型前綴避免比對到錯誤的項目
export function getContentItemId(item) {
  if (item.post_info) return `post-${item.post_info.post_id}`;
  if (item.world_info) return `world-${item.world_info.world_id}`;
  return item.id;
}
